const initialState = {
    data: {},
    similar: [],
    options: [],
    selectGrade: {},
    statusShow: false,
    numberInput: 1,
    loader: false,
};
const modalProduct = (state = initialState, action) => {
    switch (action.type) {
        case 'OPEN_MODAL_PRODUCT':
            return {...state, statusShow: true};
        case 'CLOSE_MODAL_PRODUCT':
            return {...state, statusShow: false};
        case 'CHANGE_BASE_CARD_PRODUCT':
            return {...state, data: action.data, similar: action.similar, options: action.options};
        case 'CHANGE_BASE_SELECT_GRADE_MODAL_PRODUCT':
            const {number_input: selected_number_input} = action.selectGrade;
            return action.option !== undefined
                ? {
                    ...state, selectGrade: action.selectGrade, numberInput: selected_number_input
                        ? selected_number_input
                        : parseFloat(action.selectGrade.min_amount),
                    options: state.options.map(option => {
                        return option.id === action.option.id ? {...action.option, default: "1"} : {
                            ...option,
                            default: "0"
                        }
                    })
                }
                : {
                    ...state, selectGrade: action.selectGrade, numberInput: selected_number_input
                        ? selected_number_input
                        : parseFloat(action.selectGrade.min_amount)
                };
        case 'CHANGE_INPUT_NUMBER_MODAL_PRODUCT':
            const {min_amount, inventory} = state.selectGrade;
            const step = parseFloat(min_amount);
            let result = state.numberInput;
            if (action.direction === "up")
                result = state.numberInput + step;
            else if (action.direction === "down") {
                result = state.numberInput - step;
            } else {
                if (action.direction > parseInt(inventory)) {
                    return {...state, numberInput: parseInt(inventory)};
                } else if (action.direction < step)
                    return {...state, numberInput: step};
                else
                    return {...state, numberInput: action.direction};
            }
            if (result > parseInt(inventory))
                return {...state, numberInput: parseInt(inventory)};
            // else if (result < step)
            //     return {...state, numberInput: step};
            else if (result < 0)
                return {...state, numberInput: 0};
            else
                return {...state, numberInput: result % 1 === 0 ? result : parseFloat(result.toFixed(2))};
        case 'CHANGE_LOADER_MODAL_PRODUCT':
            return {...state, loader: action.loader};
        case 'CHANGE_ITEM_OPTION_MODAL_PRODUCT':
            return action.name === 'options' ? {
                ...state, options: state.options.map(option => {
                    return option.id === action.value ? {...option, default: "1"} : {...option, default: "0"};
                })
            } : state;
        default:
            return state;
    }
};

export default modalProduct;
